/**
 * Tipos 10XX = 1000 + event_type_id (gestores restringidos por tipo de evento).
 */
export const BACKOFFICE_GESTOR_TYPE_LABELS = {
  1001: "Gestor MICFootball",
  1002: "Gestor MICFootball7",
  1003: "Gestor MICBasketball",
  1004: "Gestor MIC CAMP",
  1005: "Gestor Pau Gasol Academy",
  1006: "Gestor Eurockey",
  1007: "Gestor La Liga Genuine",
  1008: "Gestor Mundo Deportivo Futcamp",
  1009: "Gestor DNC",
  1010: "Gestor Trials",
  1011: "Gestor Altres",
  1012: "Gestor MICCAMP BCN",
  1013: "Gestor MundoDeportivo FUTCAMP",
  1014: "Gestor MICFootfem",
  1015: "Gestor MICFootball Punta Cana",
  1016: "Gestor Aitana Bonmati Campus"
};

export function formatBackofficeGestorType(value) {
  const v = parseInt(value, 10);
  if (v === 2) {
    return "Gestor";
  }
  if (v === 3) {
    return "Gestor2";
  }
  return BACKOFFICE_GESTOR_TYPE_LABELS[v] || "";
}

export function isRestrictedEventTypeUserType(type) {
  const t = parseInt(type, 10);
  return t >= 1001 && t <= 1016;
}

/** Opciones { text, value } para selects (filtros listado + formularios). */
export function getBackofficeGestorTypeSelectOptions() {
  const base = [
    { text: "Gestor", value: 2 },
    { text: "Gestor2", value: 3 }
  ];
  const extra = Object.keys(BACKOFFICE_GESTOR_TYPE_LABELS).map(k => ({
    text: BACKOFFICE_GESTOR_TYPE_LABELS[k],
    value: parseInt(k, 10)
  }));
  return base.concat(extra);
}
